import { SHOW_NOTIFICATION } from './actionType'

export const initialState = {
  isShown: false,
  message: '',
  type: '',
}

export default function notificationReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_NOTIFICATION: {
      const { payload } = action
      const { isShown, message, type = 'error' } = payload
      const newState = {
        ...state,
        isShown,
        message,
        type,
      }
      return newState
    }
    default:
      return state
  }
}
